import LikeAnimation from "./LikeAnimation";
export default LikeAnimation;
